import { Controller } from "@hotwired/stimulus"

// Generic click-to-edit for a single cell.
// HTML contract:
//   <div data-controller="inline-edit">
//     <div data-inline-edit-target="display"
//          data-display-class="inline-flex"
//          data-action="click->inline-edit#edit">...</div>
//     <form data-inline-edit-target="input" class="hidden">...</form>
//   </div>
// `data-display-class` is restored when the display is re-shown, because
// Tailwind's `inline-flex`/`inline-block` utilities are generated after
// `.hidden` and would otherwise win the cascade.
export default class extends Controller {
  static targets = ["display", "input"]

  connect() {
    this.hide(this.inputTarget)
    this.show(this.displayTarget)
  }

  edit(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.hide(this.displayTarget)
    this.show(this.inputTarget)

    const field = this.inputTarget.querySelector("input, select, textarea")
    if (field) {
      field.focus()
      if (typeof field.select === "function") field.select()
    }
  }

  cancel() {
    this.show(this.displayTarget)
    this.hide(this.inputTarget)
  }

  save() {
    const form = this.inputTarget.tagName === "FORM"
      ? this.inputTarget
      : this.inputTarget.closest("form")
    if (form) form.requestSubmit()
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }

  show(el) {
    if (!el) return
    el.classList.remove("hidden")
    const displayClass = el.dataset.displayClass
    if (displayClass) el.classList.add(displayClass)
  }

  hide(el) {
    if (!el) return
    const displayClass = el.dataset.displayClass
    if (displayClass) el.classList.remove(displayClass)
    el.classList.add("hidden")
  }
}
